module.exports = __webpack_public_path__ + "static/media/BrandLogo.5da0a2a6.png";